/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";

import { classnames } from "../../../utils/text";
import Icon from "../../../components/Icon";
import { 
  SI4N_TYPES, 
  // TEST_TAX_PAYER_LIST 
} from "../../../constants/TaxPortal/SI4N";
import { shallowEqual, useSelector } from "react-redux";
import { isEmpty, sortBy } from "lodash";
import Filters from "../../../components/Filters";
import useForm from "../../../hooks/useForm";
import Loading from "../../../components/Loading";
import { now } from "../../../utils/date";

import NationalPension from "../../../components/Si4n/NationalPension/index";
import HealthInsurance from "../../../components/Si4n/HealthInsurance";

const si4nTypes = SI4N_TYPES;



const formatYearMonth = (dateString) => {
  if (!dateString) return null
  return dateString.slice(0, 4) + dateString.slice(5, 7);
}


const Si4Item = ({ icon, disabled, label, id, action }) => {


  return <div className={classnames("issue-button-box w-50", {
    disabled,
  })}>
    <a
      className={classnames("issue-button")}
      onClick={() => {
        if (disabled) return;
        action()
      }}
    >
      <span className="icon">
        <Icon src={icon} />
      </span>
      {label}
    </a>
  </div>;
};


const Si4n = (props) => {

  //---------- dev
  // const taxpayerList = TEST_TAX_PAYER_LIST;
  // const __selectedCareCompanyIdx = '31888022270'
  // const __selectedSi4n = SI4N_TYPES[1].id

  // --------- live
  const { taxpayerList } = useSelector(
    (store) => ({
      taxpayerList: store.Data.taxpayerList,
    }),
    shallowEqual
  );
  const __selectedCareCompanyIdx = null
  const __selectedSi4n = null

  const [filters, setFilters] = useState([]);

  const [selectedSi4n, setSelectedSi4n] = useState(__selectedSi4n);


  useEffect(() => {
    setFilters([
      {
        title: "수임처 (사업장관리번호 자동완성)",
        type: "search-select",
        key: "selectedCareCompanyIdx",
        options: {
          placeholder: '수임처 입력 및 선택',
          list: [...sortBy(
            taxpayerList.map(b => ({
              label: `${b.companyName}${!isEmpty(b.ceoName) ? ` (${b.ceoName})` : ""}`,
              value: b.idx
            })),
            ["label"]
          )],
          zIndex: 100,
          isControlShouldRenderValue: true,
        },
      },
      {
        title: "날짜",
        key: 'date',
        // type: "customdatepicker",
        type: "datepicker",
      },
      {
        title: "사업장관리번호",
        type: "input",
        key: "mgmtNo",
        options: {
          placeholder: '관리번호확인해주세요, "-"제외하고 입력,',
        },
      },
    ])
  }, [taxpayerList])

  const {
    form,
    handleOnChange,
    setForm,
    // filterSubmit,
  } = useForm(
    {
      selectedCareCompanyIdx: __selectedCareCompanyIdx,
      mgmtNo: '',
      date: now(),
    },
  );


  useEffect(() => {
    console.log('form : ', form)
    if (form.selectedCareCompanyIdx && !isEmpty(taxpayerList)) {
      const _selectedCareCompnay = taxpayerList.find((c) => c.idx === form.selectedCareCompanyIdx)
      if (form.mgmtNo === _selectedCareCompnay?.bsno + '0') return
      setForm({
        mgmtNo: _selectedCareCompnay?.bsno + '0'
      })
    }
  }, [form])

  return (
    <>
      {isEmpty(taxpayerList) ?
        <Loading>
          수임처가 없거나 수임처를 불러오는 중입니다.
        </Loading>
        : <>
          <div className="tax-portal si4n">
            <PageHeader title={`4대보험조회`} />

            <div className="si4n-description-wrap">
              <div className="si4n-description-text-wrap">
                <span className="si4n-description-text">
                  EDI 에서 수집 가능한 수임업장만 조회 가능합니다.<br />
                  업무 참고용으로 금액이 상이할 수 있습니다.
                </span>
              </div>
            </div>

            <Filters
              // isLoading={isLoading}
              filters={filters}
              form={form}
              onChange={handleOnChange}
              isSubmitButton={false}
            />
            <div className="task-issue-list-wrap">

              <div className="task-issue-list-box">
                <div className="task-issue-list">
                  {si4nTypes
                    .filter(({ id }) => !!id)
                    .map(({ label, id, icon, disabled }, idx) => (
                      <Si4Item
                        id={id}
                        icon={icon}
                        label={label}
                        disabled={disabled || form?.mgmtNo === ''}
                        key={idx}
                        action={
                          () => setSelectedSi4n(id)
                        }
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
          <NationalPension
            mgmtNo={form?.mgmtNo}
            date={form?.date[0] ? formatYearMonth(form?.date[0]) : null}
            open={selectedSi4n === 'nationalPension'}
            setOpen={setSelectedSi4n}
          />
          <HealthInsurance
            mgmtNo={form?.mgmtNo}
            date={form?.date[0] ? formatYearMonth(form?.date[0]) : null}
            open={selectedSi4n === 'healthInsurance'}
            setOpen={setSelectedSi4n}
          />
        </>}
    </>

  );
};

export default Si4n;
